import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {
  CUSTOM_SHADOW_MAX_BLUR,
  CUSTOM_SHADOW_MIN_BLUR,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-custom-shadow-blur-option/base-item-custom-shadow-blur-option.types';

interface BaseItemCustomShadowBlurOptionProps {
  dropShadowBlur: number;
  className?: string;
  onUpdateBlur(dropShadowBlur: number, undoable?: boolean): void;
}

export function BaseItemCustomShadowBlurOption({className = '', ...props}: BaseItemCustomShadowBlurOptionProps): ReactElement<any> | null {
  const onChangeBlur = (updatedBlur: number): void => {
    props.onUpdateBlur(updatedBlur, false);
  };

  const onChangeBlurEnded = (updatedBlur: number): void => {
    props.onUpdateBlur(updatedBlur);
  };

  return (
    <ContextualMenuSliderOptions
      id="custom-shadow-blur"
      className={className}
      value={props.dropShadowBlur}
      label={window.i18next.t('pmwjs_blur')}
      range={{
        min: CUSTOM_SHADOW_MIN_BLUR,
        max: CUSTOM_SHADOW_MAX_BLUR,
      }}
      transformDisplay={{
        min: CUSTOM_SHADOW_MIN_BLUR,
        max: CUSTOM_SHADOW_MAX_BLUR,
      }}
      onChange={onChangeBlur}
      onChangeEnded={onChangeBlurEnded}
    />
  );
}
